import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@material-ui/core';
import useStyles from './Callout.style.js';
import ChowbusTitle from '../../ChowbusTitle.jsx';

/**
 * Show the text indented and colored appropriately for a Callout
 * @param {object} props
 * @param {React.ReactNode} props.children - the text to render
 * @param {string} [props.component] - the html component used to render the wrapper (compatible with @material-ui/core/Typography)
 * @param {string} [props.textClassName] - the html component used to render the wrapper (compatible with @material-ui/core/Typography)
 * @see Callout
 */
const CalloutText = (props) => {
  const { children, component = 'p', textClassName } = props;
  const classes = useStyles();
  return (
    <Typography
      paragraph
      align='center'
      variant='body2'
      component={component}
      className={`${classes.text} ${textClassName ? textClassName : ''}`}>
      {children}
    </Typography>
  );
};

/**
 * A big heading with a pop of color to the left, and a paragraph or more of text.
 */
const Callout = (props) => {
  const { title, text, children, titleBorderColor, titleClass = null, textClass = null } = props;
  const classes = useStyles(props);

  return (
    <Grid container direction='column' style={{ position: 'relative' }}>
      <div
        style={{
          position: 'absolute',
          top: 10,
          left: 0,
          height: 28,
          borderLeft: `8px solid ${titleBorderColor}`,
        }}></div>
      <ChowbusTitle className={`${classes.title} ${titleClass || ''}`}>{title}</ChowbusTitle>
      {text && <CalloutText textClassName={textClass || ''}>{text}</CalloutText>}
      {children}
    </Grid>
  );
};

Callout.propTypes = {
  /**
   * The big heading
   */
  title: PropTypes.string.isRequired,
  /**
   * if you just have simple text, you can just pass this string and leave the body empty
   */
  text: PropTypes.string,
  /**
   * if you need to render complext content, pass in children. See CalloutText for help styling your content.
   */
  children: PropTypes.node,
  /**
   * color of the left border
   */
  titleBorderColor: PropTypes.string,

  titleClass: PropTypes.string,
  textClass: PropTypes.string,
};

Callout.defaultProps = {
  titleBorderColor: '#e00051',
};
export default Callout;
export { CalloutText };
